
export const viewFormOption =  {
    submitText: '提交',
    submitBtn: false,
    emptyBtn: false,
    labelWidth: 120,
    column: [],
    group: [
      {
        column: [
            {
                label: "项目名称",
                prop: "projectId",
                disabled:true,
                type: 'select',
                searchClearable: false,
                search: true,
                dicUrl: '/api/v4ward/project/getProjectList',
                props: {label: 'name', value: 'id'},
            },
            {
                label: "考核类型",
                prop: "type",
                type: "select",
                search: true,
                disabled:true,
                dataType: 'number',
                dicUrl: "/api/blade-system/dict/dictionary?code=examine_type",
                dicData: [],
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
              },

          {
            label: "填报人数",
            prop: "fillCount",
            disabled:true,
          },
          {
            label: "总分值",
            prop: "totalScore",

            dataType: 'number',
            disabled:true,
          },
          {
            label: "平均分值",
            prop: "averageScore",
            slot:true,
            disabled:true,
          },
          {
            label: "基准分值",
            prop: "baseScore",
            disabled:true,
          },
          {
            label: "关联合同",
            prop: "contractName",
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            disabled:true,
          },
          {
            label: "合同编号",
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            prop: "contractCode",
            disabled:true,
          },
          {
            label: "考核开始时间",
            prop: "startTime",
            disabled:true,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: "考核结束时间",
            prop: "endTime",
            disabled:true,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',

          },
          {
            prop: 'test',
            label: '子报告',
            formslot: true,
            labelslot: true,
            span: 24,
            row:true,
          },
        ]
      },
    ],
  };

  export const topicOption = {
    calcHeight: 50,
    height: '400',
    indexLabel:'序号',
    page: false,
    border: true,
    addBtn: false,
    selection: false,
    tip: false,
    columnBtn: false,
    refreshBtn: false,
    menuAlign: 'center',
    menu: false,
    align:'center',
    column: [
        {
            label: "项目名称",
            prop: "projectId",
            hide:true,
            cascaderItem: ['serviceType'],
            cascaderChange: true,
        },
      {
        label: "考核对象",
        prop: "serviceType",
        dataType: 'string',
        dicUrl: `/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}`,
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        maxlength: 30,
        showWordLimit: true,
        overHidden: true,
      },
      {
        label: "填报人数",
        prop: "fillCount",
        span: 24,
        row: 2,
        maxlength: 200,
        showWordLimit: true,
        overHidden: true,
      },
      {
        label: "总分值",
        prop: "totalScore",
        maxlength: 6,
        showWordLimit: true,
      },
      {
        label: "平均分值",
        prop: "averageScore",
        maxlength: 6,
        slot:true,
        showWordLimit: true,
      },
      {
        label: "基准分值",
        prop: "baseScore",
      },
    ]
}

export const unqualifiedOption = {
    calcHeight: 50,
    height: '400',
    indexLabel:'序号',
    page: true,
    border: true,
    addBtn: false,
    selection: false,
    tip: false,
    columnBtn: false,
    refreshBtn: false,
    menuAlign: 'center',
    align:'center',
    menu: false,
    column: [

      {
        label: "填表科室",
        prop: "deptName",
      },
        {
            label: "填表人",
            prop: "userName",
        },
        {
          label: "手机号",
          prop: "phone",
        },
        {
            label: "项目名称",
            prop: "projectId",
            hide:true,
            cascaderItem: ['serviceType'],
            cascaderChange: true,
        },
      {
        label: "考核对象",
        prop: "serviceType",
        dataType: 'string',
        dicUrl: `/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}`,
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        maxlength: 30,
        showWordLimit: true,
        overHidden: true,
      },
      {
        label: "内容",
        prop: "content",
        span: 24,
        row: 2,
        maxlength: 200,
        showWordLimit: true,
        overHidden: true,
      },
      {
        label: "分值",
        prop: "score",
        maxlength: 6,
        showWordLimit: true,
      },
      {
        label: "打分值",
        prop: "evaluateScore",
      },
    ]
}
